import React from 'react';
const GlobalWarning = (props) => {
	return (
		<div id="global-warning" className="global-warning">
			<div className="container text-center">
                <div className="warning-text position-relative" data-toggle="tooltip" title="Message">
                    {/* <span className="close-icon">
                        <i className="fas fa-times"></i>
                    </span> */}
                    <p>{props.message}</p>
                </div>
            </div>
        </div>
	);
};

export default GlobalWarning;